/**
 * FileManager Query Keys
 *
 * Centralized React Query key definitions for cache management.
 * All query keys follow the pattern: [feature, entity, action?, params?]
 */

import type { FolderQueryParams, EntriesQueryParams, NodesQueryParams } from "../services/file-manager.service.types";

export const FILE_MANAGER_QUERY_KEYS = {
  // Root key for all file manager queries
  all: ["fileManager"] as const,

  // Folder queries
  folders: () => [...FILE_MANAGER_QUERY_KEYS.all, "folders"] as const,
  foldersList: (params: FolderQueryParams) => [...FILE_MANAGER_QUERY_KEYS.folders(), "list", params] as const,
  rootFolders: (params: Omit<FolderQueryParams, "parent_id">) => [...FILE_MANAGER_QUERY_KEYS.folders(), "root", params] as const,
  folderDetails: (id: string | null) => [...FILE_MANAGER_QUERY_KEYS.folders(), "details", id] as const,
  folderNavigation: (path: string) => [...FILE_MANAGER_QUERY_KEYS.folders(), "navigate", path] as const,

  // Entry queries
  entries: () => [...FILE_MANAGER_QUERY_KEYS.all, "entries"] as const,
  entriesList: (folderId: string | null, params: EntriesQueryParams) =>
    [...FILE_MANAGER_QUERY_KEYS.entries(), "list", folderId, params] as const,
  entryDetails: (folderId: string | null, entryId: string | null) =>
    [...FILE_MANAGER_QUERY_KEYS.entries(), "details", folderId, entryId] as const,

  // Everything a folder deletion would take along
  folderContentsCount: (folderIds: string[]) => [...FILE_MANAGER_QUERY_KEYS.folders(), "contentsCount", folderIds] as const,

  // Nodes queries (combined folders + entries)
  nodes: () => [...FILE_MANAGER_QUERY_KEYS.all, "nodes"] as const,
  nodesList: (params: NodesQueryParams) => [...FILE_MANAGER_QUERY_KEYS.nodes(), "list", params] as const,
} as const;
